import { SourceType } from 'module/api/filter/types';
import { FieldType } from 'module/types/filter-field/field/field';
import { SingleSelectField } from 'module/types/filter-field/field/filterable-field';
import { useExternalTeamMemberFieldsAsFilterableField } from 'helpers/fields/external-team-members-fields/fields';
import { useMemo } from 'react';

export const NoneFieldKey = 'none';
export const NoneField: SingleSelectField = {
  fieldName: 'none',
  fieldLabel: 'None',
  type: FieldType.SingleSelect,
  fieldId: -2000,
  private: false,
  customField: false,
  metaData: {
    options: [],
  },
  sourceType: SourceType.User,
};

export const usePeoplePageGroupByFields = () => {
  const { fields: userFields, loading: isUserFieldsLoading } =
    useExternalTeamMemberFieldsAsFilterableField();
  const allowedFields = useMemo(() => {
    return userFields.filter((field) =>
      [FieldType.SingleSelect, FieldType.SingleUser].includes(field.type),
    );
  }, [userFields]);

  return useMemo(() => {
    return {
      fields: [NoneField, ...allowedFields],
      loading: isUserFieldsLoading,
    };
  }, [allowedFields, isUserFieldsLoading]);
};
